export default __webpack_public_path__ + "static/media/rawpixel-comm.63b18e5f.jpg";